<template>
  <div class="nt-popover" @mouseenter="visible = true" @mouseleave="visible = false">
    <span ref="trigger" class="nt-popover__trigger" role="button">
      <slot />
    </span>

    <div
      ref="content"
      class="nt-popover__content"
      :class="visible ? 'is-active' : ''"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      rect: null,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.setContentCoordinate();
      } else {
        this.rect = null;
      }
    },
  },
  methods: {
    setContentCoordinate() {
    this.$nextTick(() => {
      const trigger = this.$refs.trigger.getBoundingClientRect();
      const content = this.$refs.content;

      const popoverWidth = content.offsetWidth;
      const viewportWidth = window.innerWidth;

      const top = trigger.top - (trigger.height / 2);
      const spaceRight = viewportWidth - trigger.right;
      const spaceLeft = trigger.left;

      content.style.top = `${top}px`;
      content.style.left = 'auto';
      content.style.right = 'auto';

      if (spaceRight < popoverWidth && spaceLeft >= popoverWidth) {
        content.style.left = `${trigger.left - popoverWidth}px`;
        content.classList.add('is-left');
      } else {
        content.style.left = `${trigger.right}px`;
        content.classList.remove('is-left');
      }
    });
  },
  },
};
</script>

<style lang="scss">
$shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

.nt-popover__content {
  display: none;
  position: fixed;
  background-color: #fff;
  padding: 12px;
  border-radius: 4px;
  min-width: 300px;
  box-shadow: $shadow;
  z-index: 100;

  &.is-active {
    display: block;
  }

  &::after {
    content: '';
    position: absolute;
    top: 12px;
    left: -6px;
    width: 12px;
    height: 12px;
    background: #fff;
    transform: rotate(45deg);
  }

  &.is-left::after {
    left: auto;
    right: -6px;
  }
}
</style>
